module.exports = __webpack_public_path__ + "img/mask-240323.3504865d.svg";